"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _styles = require("@material-ui/core/styles");

var _taggingHelper = require("@eig-builder/core-utils/helpers/tagging-helper");

var _TextField = _interopRequireDefault(require("@eig-builder/core-ui/TextField"));

var _withContext = _interopRequireDefault(require("../../helpers/with-context"));

var _moduleLocalization = require("@eig-builder/module-localization");

var _mobileDetectionHelper = _interopRequireDefault(require("@eig-builder/core-utils/helpers/mobile-detection-helper"));

var _hooks = require("../../hooks");

require("./style/search-field.scss");

require("../../lang");

var _templateObject;

var styles = {
  root: {
    marginRight: 20
  },
  mobile: {
    marginLeft: 16
  }
};
var StyledTextField = (0, _styledComponents["default"])(_TextField["default"])(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2["default"])(["\n  margin-right: 20px !important;\n"])));

var SearchField = function SearchField(_ref, context) {
  var classes = _ref.classes,
      view = _ref.view;

  var _useSearchQuery = (0, _hooks.useSearchQuery)(),
      search = _useSearchQuery.search,
      setSearchQuery = _useSearchQuery.setSearchQuery;

  var contextLocalize = (0, _moduleLocalization.useLocalize)();

  var removeSpecialCharacters = function removeSpecialCharacters(value) {
    return value.replace(/[^a-zA-ZÀ-ÖØ-öø-ÿ0-9-& ]/g, '');
  };

  var doSearch = function doSearch(value, view) {
    var removedSpecialChars = removeSpecialCharacters(value);
    setSearchQuery(removedSpecialChars, view);
  };

  var onChange = function onChange(_ref2) {
    var value = _ref2.target.value;

    if (value !== search.query) {
      doSearch(value, view);
    }
  };

  var onKeyUp = function onKeyUp(_ref3) {
    var value = _ref3.target.value,
        keyCode = _ref3.keyCode;

    if (keyCode === 13) {
      doSearch(value, view);
    }
  };

  return /*#__PURE__*/_react["default"].createElement(StyledTextField, {
    placeholder: contextLocalize.localize('imagepicker.searchForImages'),
    value: search.query,
    onChange: onChange,
    onKeyUp: onKeyUp,
    variant: "outlined",
    dataElementLabel: "image-selector--nav--search-images",
    dataElementLocation: _taggingHelper.DataElementLocations.BODY,
    dataElementId: "image-selector--nav--search-images",
    fullWidth: (0, _mobileDetectionHelper["default"])()
  });
};

SearchField.propTypes = {
  classes: _propTypes["default"].object,
  view: _propTypes["default"].string
};
var contexted = (0, _withContext["default"])(SearchField);

var _default = (0, _styles.withStyles)(styles)(contexted);

exports["default"] = _default;